import React from 'react';
import FormattedCurrency from '@/shared/components/FormattedCurrency';
import classnames from 'classnames';

const AmountColumnValue = ({ value, className }) =>
  !value && value !== 0 ? null : (
    <span
      className={classnames(
        'amount',
        { 'text-muted': !value, 'text-danger': value < 0 },
        className,
      )}
    >
      <FormattedCurrency value={value} />
    </span>
  );
export default AmountColumnValue;
